
import Vue from "vue";

const POPUP_WIDTH = 320;
const VIEWPORT_MARGIN = 8;
const BUTTON_SPACING = 6;

export default Vue.extend({
	data(){
		return {
			open: false,
			top: 0,
			left: 0,
			width: POPUP_WIDTH
		};
	},
	props: {
		text: String,
		title: String,
		linkTo: String,
		linkText: String
	},
	methods: {
		toggle(){
			if (this.open){
				this.close();
				return;
			}
			this.show();
		},
		show(){
			this.open = true;
			this.width = Math.min(POPUP_WIDTH, window.innerWidth - VIEWPORT_MARGIN * 2);
			this.$nextTick(()=>this.updatePosition());
			document.addEventListener("click", this.close);
			document.addEventListener("keydown", this.onKeyDown);
			window.addEventListener("resize", this.close);
			window.addEventListener("scroll", this.close, true);
		},
		close(){
			if (!this.open) return;
			this.open = false;
			document.removeEventListener("click", this.close);
			document.removeEventListener("keydown", this.onKeyDown);
			window.removeEventListener("resize", this.close);
			window.removeEventListener("scroll", this.close, true);
		},
		onKeyDown(event:KeyboardEvent){
			if (event.key != "Escape") return;
			this.close();
		},
		updatePosition(){
			let button = this.$refs.button as HTMLElement | undefined;
			let popup = this.$refs.popup as HTMLElement | undefined;
			if (!button || !popup) return;

			let buttonBox = button.getBoundingClientRect();
			let left = buttonBox.left + buttonBox.width / 2 - this.width / 2;
			this.left = Math.max(VIEWPORT_MARGIN, Math.min(left, window.innerWidth - this.width - VIEWPORT_MARGIN));

			let popupHeight = popup.getBoundingClientRect().height;
			let below = buttonBox.bottom + BUTTON_SPACING;
			if (below + popupHeight + VIEWPORT_MARGIN > window.innerHeight && buttonBox.top - popupHeight - BUTTON_SPACING > VIEWPORT_MARGIN){
				this.top = buttonBox.top - popupHeight - BUTTON_SPACING;
				return;
			}
			this.top = Math.min(below, window.innerHeight - popupHeight - VIEWPORT_MARGIN);
		}
	},
	beforeDestroy(){
		this.close();
	}
});
